<div class="relative grid grid-cols-1 gap-8 mt-8">

    <div *ngIf="video" class="top-0 w-full row-span-full">
        <div class="flex justify-end">

            <div class="grow">
                <button [routerLink]="['..']"
                    class="text-primary-500 hover:bg-primary-100 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-chevron-left mr-2 leading-relaxed"></i>
                    Back
                </button>
            </div>

            <div>
                <!-- <button (click)="deleteVideo()" [disabled]="working"
                        class="bg-red-500 text-white active:bg-red-500 hover:bg-red-300 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-3 ease-linear transition-all duration-150"
                        type="button"><i class="fa fa-trash-can mr-2 leading-relaxed"></i>
                        Delete
                    </button> -->

                <!-- <button [routerLink]="['edit']"
                        class="bg-primary-400 active:bg-primary-500 hover:bg-primary-700 text-white hover:shadow-lg shadow text-sm font-bold uppercase px-4 py-2 rounded outline-none focus:outline-none mr-3 ease-linear transition-all duration-150"
                        type="button"><i class="fa fa-edit mr-2 leading-relaxed"></i>Edit
                    </button> -->
                <!-- 
                    <button (click)="refreshRecord()" [disabled]="working"
                        class="bg-primary-400 text-white active:bg-primary-500 hover:bg-primary-700 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none {{video.publishStatus == 'review' ? 'mr-3' : ''}}  ease-linear transition-all duration-150"
                        type="button"><i class="fa fa-refresh mr-2 leading-relaxed"></i>
                        Refresh
                    </button>

                    <button *ngIf="video.publishStatus == 'review'" (click)="publishVideo()" [disabled]="working"
                        class="bg-secondary-500 text-white active:bg-primary-500 hover:bg-secondary-700 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"><i class="far fa-check-circle mr-2 leading-relaxed"></i>
                        Publish
                    </button> -->
            </div>
        </div>
    </div>

    <div class="relative flex flex-col break-words w-full lg:mr-6 mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">

        <form *ngIf="video" [formGroup]="updateForm" (ngSubmit)="update()">
            <div class="rounded-t bg-white mb-0 px-6 py-4">
                <div class="text-center flex justify-between items-center">
                    <span class="text-blueGray-700 text-lg font-bold">Update Video</span>
                </div>
            </div>

            <div class="flex flex-wrap px-6 py-4">
                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Title *
                    </label>
                    <input type="text" type="title" formControlName="title" id="title" name="title" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full py-1.5 px-3 ease-linear transition-all duration-150"
                        rows="4" />
                    <div
                        class="{{ updateForm.get('title')?.invalid && (updateForm.get('title')?.dirty || updateForm.get('title')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        <p *ngIf="updateForm.get('title')?.errors?.['required']">
                            Value is required
                        </p>
                        <p
                            *ngIf="updateForm.get('title')?.errors?.['minlength'] || updateForm.get('title')?.errors?.['maxlength']">
                            Min 10 and max 200 characters required
                        </p>
                    </div>
                </div>

                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Description *
                    </label>
                    <textarea type="text" type="description" formControlName="description" id="description"
                        name="description" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 whitespace-pre-line bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        rows="4">{{video.description}}
                            </textarea>
                    <div
                        class="{{ updateForm.get('description')?.invalid && (updateForm.get('description')?.dirty || updateForm.get('description')?.touched) ? 'visible' : 'invisible'}} h-6 text-red-500 text-xs">
                        <p *ngIf="updateForm.get('description')?.errors?.['required']">
                            Value is required
                        </p>
                        <p
                            *ngIf="updateForm.get('description')?.errors?.['minlength'] || updateForm.get('description')?.errors?.['maxlength']">
                            Min 10 and max 500 characters required
                        </p>
                    </div>
                </div>

                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Tags
                    </label>
                    <div class="flex flex-wrap gap-1">
                        <button (click)="removeTag(i)" type="button" *ngFor="let item of tags; index as i"
                            data-dismissible="chip"
                            class="relative flex select-none items-center whitespace-nowrap rounded-lg bg-primary-500 py-1.5 px-3 my-1 text-xs font-bold text-white">
                            <span class="grow-0">{{item}}<i class="fa fa-close ml-2 leading-relaxed"></i></span>
                        </button>
                    </div>
                    <div class="flex flex-row align-middle mt-2">
                        <input formControlName="tagField" id="tagField" name="tagField" type="text"
                            class="border-0 grow placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                        <button (click)="addTag()" type="button"
                            class="bg-primary-500 basis-1/4 whitespace-nowraprounded ml-4 text-xs text-white px-2">Add
                            Tag</button>
                    </div>
                    <div
                        class="{{updateForm.get('tagField')?.invalid && (updateForm.get('tagField')?.dirty || updateForm.get('tagField')?.touched)? 'visible' : 'invisible' }} pt-1 h-4 text-red-500 text-xs">
                        @if(updateForm.get('tagField')?.errors?.['required']) {
                        <p>Value is required</p>
                        } @else if(updateForm.get('tagField')?.errors?.['invalidValue']) {
                        <p>No blanks or spaces allowed</p>
                        } @else if(updateForm.get('tagField')?.errors?.['maxValuesAllowed']) {
                        <p>Only 10 values allowed</p>
                        }
                    </div>
                    <div class="w-full mb-1">
                        <button type="submit" [disabled]="!updateForm.valid || working"
                            class="bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-primary-200 mt-4 mr-2 text-white font-bold text-sm uppercase rounded px-4 py-2"
                            mat-button>
                            <div *ngIf="!working" class="inline-block">
                                <i class="fa fa-save mr-2 leading-relaxed"></i>Update
                            </div>
                            <div *ngIf="working" class="inline-block">
                                <app-loading-dots></app-loading-dots>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </form>

    </div>
</div>